/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by jessenelson on 6/2/15.
 */
'use strict';
angular.module('prism-ui.components').component('uiLock', {
    template: '<a ng-click="!$ctrl.componentDisabled && $ctrl.handleLockClick()" ng-class="$ctrl.isLocked ? \'fa fa-lock\' : \'fa fa-unlock-alt\'" tabindex="0" href=""></a>',
    controller: function(PermissionsService) {
        var self = this;

        self.handleLockClick = function (event) {
            if (PermissionsService.isAdmin()) {
                self.isLocked = !self.isLocked;
                self.clickHandler(); // Click handler is always defined due to & binding
            }
        };
    },
    bindings: {
        isLocked: '=',
        componentDisabled: '=ngDisabled',
        clickHandler: '&'
    }
});
